import React, { useEffect, useState } from 'react';
import { translate } from '../../i18n';
import { IBreakFastProps } from '../../type/breakfastComponents';
import useBgColorStore from '../../store/bgColor';
import Loader from '../../assets/loader/Loader';
import { useBreakfastDetails } from '../../hooks/apiHook/operationDetails';
import { IBreakfastDetails } from '../../type/breakfast';

const BreakFast: React.FC<IBreakFastProps> = ({
  selectedDate,
  ownerId,
  showHeading,
}) => {
  const { bgColor, updateBgColor } = useBgColorStore();
  const [breakFastDetails, setBreakFastDetails] =
    useState<IBreakfastDetails | null>(null);

  const {
    data: breakfastData,
    isLoading: isBreakfastLoading,
    isFetching: isFetching,
    refetch: refetchBreakfast,
  } = useBreakfastDetails(selectedDate, ownerId);

  useEffect(() => {
    if (breakfastData) {
      setBreakFastDetails(breakfastData);
    }
  }, [breakfastData]);

  return (
    <div className={`${bgColor}  rounded-sm  p-4 w-full`}>
      {showHeading ? (
        <>
          <h3 className="font-semibold text-base text-textColor mb-2 text-start">
            BreakFast Pax
          </h3>
        </>
      ) : null}

      {!isBreakfastLoading ||!isFetching ? (
        <>
          <div className="border-b border-b-customBorder-black mb-2"></div>
          <div className="flex justify-between">
            <div className="">
              <p className="text-textColorGray text-sm text-start">
                {translate('breakfast.breakfastPax')}
              </p>
              <p className="font-semibold text-textColorGray text-base text-start">
                <span className="text-textColorGray">
                  {breakFastDetails?.totalBreakFastPax || 0}
                </span>
              </p>
            </div>
            <div className="">
              <p className="text-textColorGray text-sm text-start">
                {translate('breakfast.exclBreakfastPax')}
              </p>
              <p className="font-semibold text-textColorGray text-base text-start">
                <span className="text-textColorGray">
                  {breakFastDetails?.totalExcludedBreakFastPax || 0}
                </span>
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-8">
            <h3 className="mt-1 mb-1 text-start text-sm text-text-primary font-bold">
              {translate('breakfast.cateringComments')}
            </h3>
            {breakFastDetails?.cateringNotesList &&
            breakFastDetails?.cateringNotesList?.length > 0 ? (
              breakFastDetails?.cateringNotesList.map((note, index) => (
                <p key={index} className="text-start text-sm">
                  {note}
                </p>
              ))
            ) : (
              <p className="text-start text-xs text-textColorGray">
                {translate('breakfast.noCateringComments')}
              </p>
            )}
          </div>
        </>
      ) : (
        <div className='flex justify-center align-middle'>
            <Loader />
        </div>
        
      )}
    </div>
  );
};

export default BreakFast;
